import { render, staticRenderFns } from "./CategoryImport.vue?vue&type=template&id=f163bad2"
import script from "./CategoryImport.vue?vue&type=script&lang=js"
export * from "./CategoryImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports